import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HasRoleGuard implements CanActivate {
  constructor(private _router: Router) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    const allowedRoles = (route.data.roles as Array<string>) || [];
    const userRoles = this.getEffectiveRoles();

    if (!userRoles.length) {
        this._router.navigateByUrl('/dashboard');
        return false;
    }

    const isAuthorized = allowedRoles.some(allowed =>
      userRoles.some(role => role.trim() === allowed.trim())
    );

    if (!isAuthorized) {
        this._router.navigateByUrl('/dashboard');
    }

    return isAuthorized;
  }

  /**
   * Prefer roles from the signed JWT (authorities). localStorage.userRole is only a fallback
   * and must not elevate access above the token.
   */
  private getEffectiveRoles(): string[] {
    const tokenRoles = this.getRolesFromAccessToken();
    if (tokenRoles.length) {
      return tokenRoles;
    }

    const storedRole = localStorage.getItem('userRole');
    return storedRole ? [storedRole] : [];
  }

  private getRolesFromAccessToken(): string[] {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return [];
    }

    try {
      const payloadPart = token.split('.')[1];
      if (!payloadPart) {
        return [];
      }
      const payload = JSON.parse(atob(payloadPart));
      if (Array.isArray(payload.authorities)) {
        return payload.authorities.filter((role: unknown) => typeof role === 'string');
      }
      return [];
    } catch {
      return [];
    }
  }
}
